import * as React from 'react';

interface CheckIconProps {
    color?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ color = 'var(--primary-color)' }: CheckIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="24.728"
            height="22.522"
            viewBox="0, 0, 24.728, 22.522"
        >
            <g transform="translate(-1.407, -0.864)">
                <path d="M2.407,14.89 L14.054,22.386 L25.135,1.864" fillOpacity="0" stroke={color} strokeWidth="2" />
            </g>
        </svg>
    );
};

export default React.memo(CheckIcon);
